import { Component, OnInit, Input } from '@angular/core';
import { uris, fontMap } from './font-data-uris';
import * as _ from 'lodash';

@Component({
  selector: '[app-font-styles]',
  templateUrl: './font-styles.component.html',
  styleUrls: ['./font-styles.component.scss']
})
export class FontStylesComponent implements OnInit {

  @Input() public links: boolean;
  public uris: any;
  public fontMap: any;
  private _fonts: string[];
  public fontString: string;

  constructor() {
    this.uris = uris;
    this.fontMap = fontMap;
    this.fontString = _.values(fontMap).join('\n');
    // console.log(this.fontString);
  }

  ngOnInit() { }

  @Input()
  get fonts() {
    return this._fonts;
  }
  set fonts(list: string[]) {
    this._fonts = list;
    // console.log(list);
    this.fontString = _.map(list, k => fontMap[k]).join('\n');
    // console.log(this.fontString);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/font-styles/font-styles.component.ts